import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Empty } from 'antd'
import cl from 'classnames'

import { Icon } from 'Shared/atoms'

import { DEFAULT_NO_DATA_PARAMS } from './constants'
import { Props } from './types'

import styles from './styles.module.scss'

const NoData: FC<Props> = ({
	noDataParams,
	className,
	iconClassName,
	imageStyle,
	descriptionClassName
}) => {
	const { t } = useTranslation()

	const {
		title = DEFAULT_NO_DATA_PARAMS.title,
		iconType = DEFAULT_NO_DATA_PARAMS.iconType,
		description = t('core:labels.noData')
	} = noDataParams || {}
	return (
		<Empty
			className={className}
			image={<Icon className={iconClassName} type={iconType} />}
			styles={{ image: { height: '40px', marginBottom: 0, ...imageStyle } }}
			description={
				<div className={styles.wrapper}>
					<span className={styles.title}>{title}</span>
					<span
						className={cl(styles.description, descriptionClassName, {
							[styles.padding]: title
						})}
					>
						{description}
					</span>
				</div>
			}
		/>
	)
}

export default NoData
